import { DefaultTheme } from "styled-components";

export default {
  title: 'default',
  primary: '#0c65ea',
  secondary: '#424242',
} as DefaultTheme;
